import './_input.scss';

function Input({type, useRef, id, label, onChange, placeholder, min, max, minLength, maxLength, text, value, children}){

    return(
        <div className='box-input'>
            <label htmlFor={id}>{label}</label>
            <div className='input-wrapper'>
                <input ref={useRef} type={type} value={value} minLength={minLength} maxLength={maxLength} id={id} placeholder={placeholder} onChange={onChange}/>
                {children}
            </div>
            <span className='required'>{text}</span>
        </div>
    )
}

export default Input;